import { useEffect } from 'react';
import useScreenShare from '@/app/hooks/useScreenShare';
import { isPermissionDeniedError } from '@/app/utils/errors';

interface ScreenShareManagerProps {
  onStop: () => void;
}

export default function ScreenShareManager({ onStop }: ScreenShareManagerProps) {
  const { screenTrack, error } = useScreenShare(true);

  useEffect(() => {
    if (!error) return;

    if (isPermissionDeniedError(error as Error)) {
      console.log('Screen share permission denied');
      onStop();
    }
  }, [error, onStop]);

  useEffect(() => {
    if (screenTrack) {
      // Handle when user stops sharing from browser UI (X button)
      const handleTrackEnded = () => {
        console.log('Screen share ended by user');
        onStop();
      };

      screenTrack.on('track-ended', handleTrackEnded);

      return () => {
        screenTrack.off('track-ended', handleTrackEnded);
      };
    }
  }, [screenTrack, onStop]);

  return null;
}
